export  function daysUntilExpiry(expiryDate) {
    const currentDate = new Date();
    const timeDiff = expiryDate.getTime() - currentDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  export  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  export  const handleRetailTotal = (qty, freeQty, retailPrice) => {
    let totalAmount = (freeQty + qty) * retailPrice;
    return totalAmount;
  };
